<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @export="exportFile"
      @checkbox-change="(rows) => (checkedRows = rows)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditPage="openEditPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>

        <el-badge
          v-if="allow('SC')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="sendContract()"
          >
            {{ $l('btn_sendContract') || '发送合同' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>

        <el-badge
          v-if="allow('P')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button ml-1"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            size="sm"
            class="ml-2"
            variant="outline-success"
            :loading="batchPushing"
            @click="batchCreateOrder()"
          >
            {{ $l('btn_batchCreateOrder') || '补推送大货订单' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <chooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{ templateGroup: 'ecom-amz-purchase' }"
      :exportOptions="{
        params: { amzPurchaseCode: chooseTemplateOptions.amzPurchaseCode },
        checkUrl: '/ecom/amz/fty/purchase/checkExport',
      }"
    />

    <SendContract
      :visible.sync="sendContractOpts.visible"
      :scmCode="sendContractOpts.scmCode"
      :listAmzPurchaseCode="sendContractOpts.listAmzPurchaseCode"
      @success="clearCheckboxRow()"
    />

    <BatchResult
      :visible.sync="batchCreateOrderOpts.visible"
      :result="batchCreateOrderOpts.result"
    />
  </div>
</template>
<script>
import lodash from 'lodash'
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import chooseTemplate from '@/views/ecom/components/choose-template'
import SendContract from '../send-contract/index.vue'
import BatchResult from '../batch-result/index.vue'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, chooseTemplate, SendContract, BatchResult },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: { visible: false, amzPurchaseCode: '' },
      checkedRows: [],
      batchPushing: false,
      batchCreateOrderOpts: {
        visible: false,
        result: {},
      },
      sendContractOpts: {
        visible: false,
        scmCode: '',
        listAmzPurchaseCode: [],
      },
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzFtyPurchaseListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query }) {
      this.$router.push({
        name: 'ecom-awsBiz-ftyPurchase-detail',
        params: { pageType, ...params },
        query,
      })
    },
    exportFile({ amzPurchaseCode }) {
      this.chooseTemplateOptions = { visible: true, amzPurchaseCode }
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    sendContract() {
      if (!this.checkedRowCount) {
        this.$message({
          type: 'warning',
          message:
            this.$l('tips_sendContract_empty') || '请选择需要发送合同的采购单',
          showClose: true,
        })
        return
      }

      const notReviewed = lodash.some(
        this.checkedRows,
        (row) => row.amzPurchaseStatus != 'Y',
      )
      if (notReviewed) {
        this.$message({
          type: 'warning',
          message:
            this.$l('tips_sendContract_notReviewed') ||
            '仅能发送已审核通过的采购单',
          showClose: true,
        })
        return
      }

      const scmCode = this.checkedRows[0]?.scmCode
      const notScm = lodash.some(
        this.checkedRows,
        (row) => !lodash.isEqual(row.scmCode, scmCode),
      )
      if (notScm) {
        this.$message({
          type: 'warning',
          message:
            this.$l('tips_sendContract_notScm') ||
            '多个执行工厂不可同时发送合同',
          showClose: true,
        })
        return
      }

      const buyerCode = this.checkedRows[0]?.buyerCode
      const notBuyer = lodash.some(
        this.checkedRows,
        (row) => !lodash.isEqual(row.buyerCode, buyerCode),
      )
      if (notBuyer) {
        this.$message({
          type: 'warning',
          message:
            this.$l('tips_sendContract_notBuyer') ||
            '多个采购跟单不可同时发送合同',
          showClose: true,
        })
        return
      }

      const listAmzPurchaseCode = lodash.map(
        this.checkedRows,
        'amzPurchaseCode',
      )

      this.sendContractOpts = {
        visible: true,
        scmCode,
        listAmzPurchaseCode,
      }
    },
    async batchCreateOrder() {
      if (!this.checkedRowCount) {
        this.$message({
          type: 'warning',
          message:
            this.$l('tips_batchCreateOrder_empty') ||
            '请选择需要补推送的采购单',
          showClose: true,
        })
        return
      }
      if (this.checkedRowCount > 100) {
        this.$message({
          type: 'warning',
          message:
            this.$l('tips_batchCreateOrder_limit') ||
            '一次最多只能补推送100条采购单',
          showClose: true,
        })
        return
      }

      const notReviewed = lodash.some(
        this.checkedRows,
        (row) => row.amzPurchaseStatus != 'Y',
      )
      if (notReviewed) {
        this.$message({
          type: 'warning',
          message:
            this.$l('tips_batchCreateOrder_notReviewed') ||
            '仅能补推送已审核通过的采购单',
          showClose: true,
        })
        return
      }

      const confirm = await this.$confirm(
        this.$l('tips_batchCreateOrder_confirm') ||
          '确认将选中的采购单补推送至数字工厂？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        },
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const listAmzPurchaseCode = lodash.map(
        this.checkedRows,
        'amzPurchaseCode',
      )

      if (this.loadingOpen()) return
      this.batchPushing = true
      let res = null
      try {
        res = await this.$api
          .ecomAmzFtyPurchaseBatchCreateOrderApi({ listAmzPurchaseCode })
          .catch(() => null)
      } finally {
        this.batchPushing = false
        this.loadingClose()
      }
      if (!res) return

      const { status, msg, body } = res
      if (status !== 200) {
        this.$message.error(msg || '补推送失败！')
        return
      }

      this.batchCreateOrderOpts = {
        visible: true,
        result: body || {},
      }
      this.clearCheckboxRow()
      this.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
